import 'src/pages/userComponents/userStyle.scss';

import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import HeaderPage from '@sharedComponent/Header/Header';
import { Helmet } from 'react-helmet';
import MainStepper from './Stepper-component/MainStepper';
import reducer from '../userComponents/menus/salesforce-landing/reducer';
import sagas from '../userComponents/menus/salesforce-landing/sagas/';
import { withReducer } from 'src/store/reducerLoader';

const steps = [
	{ title: 'Company Info', count: 1, pageIndex: 0 },
	{ title: 'Contact Info', count: 2, pageIndex: 1 },
	{ title: 'Signature', count: 3, pageIndex: 3 },
];

const User = () => {
	const history = useHistory();
	let location = useLocation();
	let step = '';

	step = useMemo(() => {
		const url = window.location.href;
		switch (url) {
			case url === 'companyinfo':
			 return 0;
			  
		    case url === 'contactinfo':
				return 1;
	    	case url === 'signature':
      		return 2;
      
			case url === 'ordercards':
				return 3;
			
		  }
		return url.indexOf('companyinfo') > -1 ? 0 : url.indexOf('contactinfo') > -1 ? 1 : url.indexOf('signature') > -1 ? 2 : 3;
	}, [location]);

	const pageTitle = steps[step]?.title;

	console.log('step', step)

	return (
		<>
			<div className="Content">
				<Helmet>
					<title>{pageTitle} | Client Onboarding</title>
				</Helmet>
				<HeaderPage />
				<MainStepper {...{ history, step }} currentStatus />
			</div>
		</>
	);
};
const ReducedScreen = withReducer('WelcomePage', reducer, sagas)(User);
export default ReducedScreen;
// export default User;
